export { ExerciseWorkoutItemActionsProvider } from "src/components/ExerciseWorkoutItemActionsProvider";
export { WorkoutItemActions } from "src/components/WorkoutItemActionsMenu";
export * from "./WorkoutItemActionsContext";
import {
  duplicateWorkoutItem,
  removeWorkoutItem as removeWorkoutItemApi,
} from "api-client";
import { useMemo } from "react";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";

import { useSaveWorkoutItemAsSection } from "./useSaveWorkoutItemAsSection";
import { useWorkoutEditStore } from "./WorkoutEditContext";
import {
  type WorkoutItemActionsHandler,
  type WorkoutItemActionsProviderProps,
  workoutItemActionsContext,
} from "./WorkoutItemActionsContext";

export function GroupWorkoutItemActionsProvider(
  props: WorkoutItemActionsProviderProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const { startSaving } = useAuthenticatedNavigationContext();
  const saveAsSection = useSaveWorkoutItemAsSection({
    workoutItemId: props.workoutItemId,
  });

  const handler = useMemo<WorkoutItemActionsHandler>(() => {
    return {
      canUnlink: false,
      saveAsSection: saveAsSection,
      duplicate: async () => {
        const stop = startSaving();
        const response = await duplicateWorkoutItem({
          path: {
            workoutId: workoutEditStore.workout.id,
            workoutItemId: props.workoutItemId,
          },
        });
        stop();
        workoutEditStore.updateItems(response.data.data.workoutItems);
      },
      delete: async () => {
        const stop = startSaving();
        const response = await removeWorkoutItemApi({
          path: {
            workoutId: workoutEditStore.workout.id,
            workoutItemId: props.workoutItemId,
          },
        });
        stop();
        workoutEditStore.updateItems(response.data.data.workoutItems);
      },
    };
  }, [workoutEditStore, props.workoutItemId, startSaving, saveAsSection]);

  const value = useMemo(() => {
    return { handler };
  }, [handler]);

  return (
    <workoutItemActionsContext.Provider value={value}>
      {props.children}
    </workoutItemActionsContext.Provider>
  );
}
